export const SocialElement = {
  align: "enum(left,center,right)",
  "background-color": "color",
  color: "color",
  "border-radius": "unit(px)",
  "font-family": "string",
  "font-size": "unit(px)",
  "font-style": "string",
  "font-weight": "string",
  href: "string",
  "icon-size": "unit(px,%)",
  "icon-height": "unit(px,%)",
  "icon-padding": "unit(px,%){1,4}",
  "line-height": "unit(px,%,)",
  name: "string",
  "padding-bottom": "unit(px,%)",
  "padding-left": "unit(px,%)",
  "padding-right": "unit(px,%)",
  "padding-top": "unit(px,%)",
  padding: "unit(px,%){1,4}",
  "text-padding": "unit(px,%){1,4}",
  rel: "string",
  src: "string",
  srcset: "string",
  sizes: "string",
  alt: "string",
  title: "string",
  target: "string",
  "text-decoration": "string",
  "vertical-align": "enum(top,middle,bottom)",
};
